import React from "react";
import styled from "styled-components";
import { Button, Modal } from "components/bootstrap";
import EntitiesList from "./EntitiesList/EntitiesList";
const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const AddEntitiesModal = ({ collectionId, onClose }) => /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onClose, fullScreen: true }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Add Content to Collection")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(EntitiesList, { collectionId })), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(StyledFooter, null, /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, "Close"))));
export default AddEntitiesModal;
